import React, { useContext } from 'react';

import { type IHome } from './HomeProvider';

const homeDefault: IHome = {
  home: {
    quickAccessBar: undefined,
    eventsBlock: undefined,
    newsletterBlock: undefined,
    proceduresBlock: undefined,
    regulationsBlock: undefined,
    sliderBlock: undefined,
    taxesBlock: undefined,
    socialNetworks: undefined,
    cabinetBlock: undefined,
  },
};

const HomeContext = React.createContext<IHome>(homeDefault);

const useHomeContext = () => useContext(HomeContext);

export { useHomeContext };

export default HomeContext;
